export default function getLetterFromIndex (index) {
  const array = `ABCDEFGHIJKLMNOPQRSTUVWXYZ`.split(``)
  return array[index]
}